import {Grid} from '@yandex-delivery/blocks'
import {LayoutSkeleton} from '@yandex-delivery/order-form/index@desktop'
import clsx from 'clsx'
import React, {memo} from 'react'

import {FloatingBox, FormBlock} from 'src/shared/components/desktop'
import {appConfig, experiments} from 'src/shared/config'
import type {DeliveryType} from 'src/shared/types'
import {
  BusinessToggle,
  DeliveryIntervalsNdd,
  DestinationPointNdd,
  DestinationPoints,
  EstimateDeliveryWidget,
  Offers,
  Parcel,
  PaymentInfo,
  PaymentMethod,
  SourcePoint,
  SourcePointNdd,
  SubmitButton,
  VerticalOptions,
  Verticals,
} from 'src/widgets/desktop'

import {useVerticals} from '../../../../widgets/VerticalsDeprecated/hooks'
import {OrderMap} from '../OrderMap/OrderMap'
import {Names} from './consts'
import {useOrderForm} from './hooks'
import * as classes from './OrderForm.classes'
import OrderFormBdui from './OrderFormBdui'

export const OrderForm = memo(function OrderForm(): React.ReactElement {
  const {isNddVertical, rawVertical, formRef, refHandler, sentinelRef} = useOrderForm()
  useVerticals()
  const shouldShowBdui = experiments.bduiVerticals && experiments.bduiVerticals.includes(rawVertical)

  // показываем скелетон пока не получили вертикали
  if (!rawVertical) {
    return (
      <div className={classes.root}>
        <div className={clsx(classes.formWrapper, {[classes.formWrapperRu]: appConfig.tld === 'ru'})}>
          <div className={classes.form} data-e2e="full-form">
            <LayoutSkeleton />
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {shouldShowBdui ? (
        <OrderFormBdui />
      ) : (
        <div className={classes.root}>
          <div className={clsx(classes.formWrapper, {[classes.formWrapperRu]: appConfig.tld === 'ru'})}>
            <div className={classes.form} data-e2e="full-form">
              <Grid ref={refHandler} size="s" container>
                <Grid xs={12} item>
                  <Verticals name={Names.VERTICALS}>
                    {experiments.isBusinessToggleVisible && <BusinessToggle name={Names.BUSINESS_TOGGLE} />}
                  </Verticals>
                </Grid>
                {isNddVertical ? (
                  <>
                    <Grid xs={12} item>
                      <SourcePointNdd />
                    </Grid>
                    <Grid xs={12} item>
                      <DestinationPointNdd name={Names.DESTINATION_POINT_NDD} />
                    </Grid>
                    <Grid xs={12} item>
                      <Parcel name={Names.PARCEL} />
                    </Grid>
                    <Grid xs={12} item>
                      <DeliveryIntervalsNdd />
                    </Grid>
                    <EstimateDeliveryWidget />
                  </>
                ) : (
                  <>
                    <Grid xs={12} item>
                      <SourcePoint />
                    </Grid>
                    <DestinationPoints name={Names.DESTINATION_POINTS} />
                    <Grid xs={12} item>
                      <VerticalOptions vertical={rawVertical} />
                    </Grid>
                    <Grid xs={12} item>
                      <Offers name={Names.OFFERS} />
                    </Grid>
                  </>
                )}
                <Grid xs={12} item>
                  <PaymentMethod name={Names.PAYMENT_METHOD} />
                  <div ref={sentinelRef} />
                </Grid>
                <Grid className={classes.button} xs={12} item>
                  <FloatingBox sentinelRef={sentinelRef}>
                    <FormBlock className={classes.submitButton}>
                      <PaymentInfo name={Names.PAYMENT_INFO} />
                      <SubmitButton formRef={formRef} rawVertical={rawVertical as DeliveryType} />
                    </FormBlock>
                  </FloatingBox>
                </Grid>
              </Grid>
            </div>
          </div>
          <div className={classes.map}>
            <OrderMap location={appConfig.location} />
          </div>
        </div>
      )}
    </>
  )
})
